<table>
    <thead>
        <tr
            class="table-header"
            [class.!bg-white]="!homeService.isExternalPage()">
            @if (isSelectable()) {
                <th
                    class="px-2"
                    (click)="toggleAllSelectedEvent.emit()">
                    <app-checkbox [checkboxState]="headerCheckboxState()" />
                </th>
            }
            @for (column of normalizedColumns(); track column) {
                <th
                    class="px-2 text-sm text-custom-dark-grey font-normal"
                    (click)="sort(column)">
                    <div
                        class="flex items-center"
                        [class]="column?.textPosition ? column.textPosition : ''"
                        [matTooltip]="column.tooltip | transloco"
                        [matTooltipDisabled]="!column.tooltip">
                        @if (column.label) {
                            {{ column.translate ? (column.label | transloco) : column.label }}

                            @if (column.sortable) {
                                <fa-icon
                                    class="text-base transition duration-200 ease-in-out"
                                    size="sm"
                                    [class]="
                                        sortState?.order && sortState?.orderBy === column.key
                                            ? 'opacity-100'
                                            : 'opacity-0'
                                    "
                                    [icon]="['fas', 'arrow-up']"
                                    [rotate]="sortState?.order === OrderEnum.DESC ? 180 : undefined" />
                            }
                        }
                    </div>
                </th>
            }
        </tr>
    </thead>
    <tbody>
        <ng-content />
    </tbody>
</table>
